import Vue from "vue";

Vue.filter("percentage", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits:2,
    maximumFractionDigits: 2
  });
  // lembrar que dividimos por 100 por 2.95 q retorna do servico é 295% e 1 é 100%
  return formatter.format(value / 100);
});
